// ES6 or Vanilla JavaScript
import { radioHideShow } from './modules/radio-hide-show.mjs'
import { tabs } from './modules/tabs.mjs'
import { searchOptionsHideShow } from './modules/searchOptionsHideShow.mjs'
import { searchRibbonHideShow, refineFilterHideShow } from './modules/searchRibbonHideShow.mjs'
import locationAutocomplete from './modules/locationAutocomplete.mjs'
import { timeoutRefocus } from './modules/timeout-refocus.mjs'

document.addEventListener('DOMContentLoaded', () => {
  // Candidate Search Page | /candidate/search
  locationAutocomplete()

  // Feedback Page
  searchOptionsHideShow()
  searchRibbonHideShow()
  refineFilterHideShow()
  radioHideShow(1)  // #radio-hide-show-container doesn't exist
  tabs()
  timeoutRefocus()
})
